<p-toast></p-toast>

<div class="container outgoing-events-container">
	<p-tabView [(activeIndex)]="selectedTabIndex">
		<p-tabPanel *ngFor="let tab of tabsConfiguration" [header]="tab.title">
			<div *ngFor="let item of tab.items">
				<cv-form-field
					*ngIf="displayForm"
					[options]="{
                        path: item.path
                    }"></cv-form-field>
			</div>
		</p-tabPanel>

		<div class="p-4 text-right">
			<button pButton [disabled]="saving || !validForm || !isDirty" [loading]="saving" label="Save" (click)="onSave()"></button>
		</div>
	</p-tabView>
</div>
